import { Navigate, Route, Routes } from "react-router";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { AboutPage } from "@/pages/AboutPage";
import { HomePage } from "@/pages/HomePage";

/**
 * The route table, kept separate from the browser router so tests can mount the real
 * thing under a MemoryRouter instead of a hand-copied list that can drift.
 */
export function AppRoutes() {
    return (
        <Routes>
            <Route element={<SiteLayout />}>
                <Route index element={<HomePage />} />
                <Route path="about" element={<AboutPage />} />
                {/* Nothing was designed for a 404 and there are no deep links to
                    preserve, so unmatched paths go home. */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
}
